// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateOtherSubjectBindingManager, ValidateCreateOtherSubjectBindingManagerSchema } from 'api/gen/ValidateCreateOtherSubjectBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateOtherSubjectBindingManager, ValidateUpdateOtherSubjectBindingManagerSchema } from 'api/gen/ValidateUpdateOtherSubjectBindingManager';

export const ValidateOtherSubjectBindingManagerSchema = t.union([ValidateCreateOtherSubjectBindingManagerSchema, ValidateUpdateOtherSubjectBindingManagerSchema]);

export type ValidateOtherSubjectBindingManager = t.TypeOf<typeof ValidateOtherSubjectBindingManagerSchema>;
